export default "__VITE_ASSET__BKpg5Pco__"